import { __exports as Container } from './_virtual-Container.js';
import { __require as requireBuild } from './vp-js-token-engine-build-index.js';
import { __require as requireHtmlIdentifier } from './vp-tokenized-fragment-build-services-htmlIdentifier.js';
import { __require as requireAvailablesLocales } from './vp-tokenized-fragment-build-services-availablesLocales.js';

var hasRequiredContainer;

function requireContainer () {
	if (hasRequiredContainer) return Container;
	hasRequiredContainer = 1;

	Object.defineProperty(Container, "__esModule", {
	  value: true
	});
	Container.tokenEngineFactory = Container.pricePresentationTokenFactory = Container.locales = Container.htmlIdentifier = void 0;
	var _vpJsTokenEngine = requireBuild();
	var _htmlIdentifier = requireHtmlIdentifier();
	var _availablesLocales = requireAvailablesLocales();
	const tokenEngineFactory = {
	  create: (culture, tenant) => new _vpJsTokenEngine.TokenEngine(culture, tenant)
	};
	Container.tokenEngineFactory = tokenEngineFactory;
	const htmlIdentifier = new _htmlIdentifier.HTMLIdentifier();
	Container.htmlIdentifier = htmlIdentifier;
	const pricePresentationTokenFactory = new _vpJsTokenEngine.PresentationTokenFactory();
	Container.pricePresentationTokenFactory = pricePresentationTokenFactory;
	const locales = (0, _availablesLocales.availablesLocales)();
	Container.locales = locales;
	
	return Container;
}

export { requireContainer as __require };
//# sourceMappingURL=vp-tokenized-fragment-build-infrastructure-Container.js.map
